const utmParams = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "utm_checkout_type",
  "utm_web_to_app",
  "utm_pseudo_id",
  "utm_ad",
  "utm_id",
]

export const persistUTMParams = () => {
  if (typeof window !== "undefined") {
    const urlParams = new URLSearchParams(window.location.search)

    utmParams.forEach((param) => {
      const value = urlParams.get(param)
      if (value) {
        localStorage.setItem(param, value)
      }
    })
  }
}

export const retrieveUTMParams = () => {
  if (typeof window !== "undefined") {
    const params: { [key: string]: string } = {}
    utmParams.forEach((param) => {
      const value = localStorage.getItem(param)
      if (value) {
        params[param] = value
      }
    })
    return params
  }
}

export const getUtmParam = (key: string) => {
  if (typeof window !== "undefined") {
    const urlParams = new URLSearchParams(window.location.search)
    const cachedValue = localStorage.getItem(key)
    return cachedValue || urlParams.get(key)
  }
}
